<script lang="ts">
  import type {AlwanColorObject} from 'alwan';
  import chroma from 'chroma-js';
  import {onDestroy, onMount} from 'svelte';
  import AlwanColorPicker from '../../../../components/alwan-color-picker/AlwanColorPicker.svelte';
  import editorInstance from '../../editor';
  import type {MappedSVGColor} from './svg.types';
  import editorStore from '../../editor.store';
  export let color: MappedSVGColor[];
  export let changeColor: () => any;
  let defColor = '#000000';
  let isGradient = false;
  let textColorPreviewElement: HTMLElement;

  const onChange = (color: string, item: MappedSVGColor) => {
    if (!color || !item || !item.element) return;
    if (item.key.includes('stop')) {
      item.element.setAttribute('stop-color', color);
    }
    editorInstance.history.addHistory('Changed Color');
    if (textColorPreviewElement) textColorPreviewElement.style.backgroundColor = color;
  };
  // const getDefaultColor = (item: MappedSVGColor): null | string => {
  //   if(item.color) return item.color.hex();
  //   return null;
  // }

  const onChangeSingle = (newColor: string) => {
    if (textColorPreviewElement) textColorPreviewElement.style.backgroundColor = newColor;
    color.forEach(item => {
      item.element.setAttribute('stop-color', newColor);
    });
  };

  const makeGradient = () => {
    isGradient = true;
  };

  const makeSingleColor = () => {
    isGradient = false;
    const baseColor = color[0].color?.hex();
    if (baseColor) {
      color[1].color = chroma(baseColor);
      onChangeSingle(baseColor);
    }
  };

  function getDefaultColor(index: number = 0): string {
    const item = color[index].element;
    return item.getAttribute('stop-color') as string;
  }

  onMount(() => {
    if (color.length) {
      if (color[0].color?.rgb.toString() == color[1].color?.rgb.toString()) {
        isGradient = false;
        console.log(textColorPreviewElement);
        setTimeout(() => {
          if (textColorPreviewElement) textColorPreviewElement.style.backgroundColor = color[0].color?.hex() as string;
          defColor = color[0].color?.hex() as string;
        }, 100);
        // if (textColorPreviewElement)
        //     textColorPreviewElement.style.backgroundColor = color[0].color?.hex() as string;
      }
    }
  });

  const unmount = editorStore.subscribe(store => {
    if (textColorPreviewElement)
      setTimeout(() => {
        textColorPreviewElement.style.backgroundColor = color[0].color?.hex() as string;
        defColor = color[0].color?.hex() as string;
      }, 100);
  });
  onDestroy(unmount);
</script>

{#if color && Array.isArray(color)}
  <div class="btn flex h-full space-x-2">
    {#if isGradient}
      <button class="flex" on:click={makeSingleColor} title="Join Gradient to single color"
        ><span class="gg-edit-noise" /></button
      >

      {#each color as item, i}
        <!-- ${item.color?.rgb()} -->
        {#key item}
          <AlwanColorPicker
            bind:changeColor
            colorDefault={getDefaultColor(i)}
            on:change-color={e => onChange(e.detail.color, item)}
          />
        {/key}
      {/each}
    {:else}
      <!-- <button class="w-8 flex" style="background: linear-gradient(to bottom right, black, white);" on:click={makeGradient} title="Make into gradient"></button> -->

      <AlwanColorPicker bind:changeColor colorDefault={defColor} on:change-color={e => onChangeSingle(e.detail.color)}>
        <div class="h-full" bind:this={textColorPreviewElement}></div>
      </AlwanColorPicker>
    {/if}
  </div>
{/if}

<style>
  .gg-edit-noise {
    --ggs: 1.2;
  }

  .gg-edit-fade {
    --ggs: 1.2;
  }
</style>
